import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LeftNavLink from './left-nav-link';
import { Icon } from '@houzz/ui';

export const NavigationLink = ({ children, title, path, depth, isPrivate }) => {
    return (
        <li>
            {depth > 0 && (
                <LeftNavLink className="left-nav__section-link" to={path} size="small">
                    {title} {isPrivate && <Icon name="lockClosed" color="content.tertiary" mr="XL" />}
                </LeftNavLink>
            )}

            {children && children.length > 0 && <NavigatonList links={children} depth={++depth} />}
        </li>
    );
};

NavigationLink.propTypes = {
    children: PropTypes.array,
    title: PropTypes.string,
    path: PropTypes.string,
    depth: PropTypes.number,
    isPrivate: PropTypes.bool,
};

export const NavigatonList = ({ links = [], section, depth = 0 }) => {
    return (
        <Fragment>
            {section && <h5 className="left-nav__section-header">{section}</h5>}
            <ul className={`left-nav__section-links left-nav__section-links--${depth}`}>
                {links.map((link) => {
                    return <NavigationLink key={link.path} {...link} depth={depth} />;
                })}
            </ul>
        </Fragment>
    );
};

NavigatonList.propTypes = {
    links: PropTypes.array,
    section: PropTypes.string,
    depth: PropTypes.number,
};
